<div [attr.class]="layout">
  <span>Contact for preview</span>
  <div class="business">
    <span class="name">{{ name }}</span>
  </div>
  <button mat-raised-button (click)="openSelectDialog()">Select another contact</button>
</div>
